export default __webpack_public_path__ + "static/media/sell1.899e290a.png";